/* Trick or treat.
   PRIZE MODE (section has data-hwt-prizes): every knock wins a discount code --
     50% code A (5% off products from $100 to $1,000), 30% code B (10% off, same range), 20% code C (20% off everything).
   One prize per visitor: the first draw is kept in localStorage and re-shown on every later knock, so
   nobody can re-knock for the jackpot. "Apply & shop" uses Shopify's /discount/CODE?redirect= link,
   which carries the code into checkout. A real product it can be spent on is suggested with it.
   This is a client-side rule (clearing site data resets it); the discounts' own admin settings
   (one use per customer, end date) are the real limit.
   Without prizes: a random product from the collection, or about one knock in five a "trick". */
(() => {
  // Loaded by the homepage section AND the site-wide popup: bind once.
  if (window.__hwTrick) return; window.__hwTrick = true;
  const KEY = 'tcgr-hw-prize-2026';
  const WEIGHTS = [0.5, 0.3, 0.2];

  document.querySelectorAll('[data-hwt]').forEach((sec) => {
    let items = [];
    try { items = JSON.parse(sec.querySelector('[data-hwt-items]').textContent || '[]'); } catch (e) { items = []; }
    const stage = sec.querySelector('.hwt__stage');
    const out = sec.querySelector('[data-hwt-reveal]');
    const label = sec.querySelector('.hwt__btn');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const ds = sec.dataset;
    const prizes = ds.hwtPrizes === 'true';
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const dec = (s) => { try { return atob(s || ''); } catch (e) { return ''; } };
    let last = -1, lastTrick = false, busy = false;

    const TIERS = prizes ? [
      { code: dec(ds.hwtA), pct: 5, over: true, title: '5% off anything from $100 to $1,000' },
      { code: dec(ds.hwtB), pct: 10, over: true, title: '10% off anything from $100 to $1,000' },
      { code: dec(ds.hwtC), pct: 20, over: false, title: '20% off everything in the store', jackpot: true }
    ] : [];

    function load() { try { const v = JSON.parse(localStorage.getItem(KEY)); return v && Number.isInteger(v.t) && v.t >= 0 && v.t < 3 ? v : null; } catch (e) { return null; } }
    function save(t) { try { localStorage.setItem(KEY, JSON.stringify({ t, at: Date.now() })); } catch (e) { /* private mode: no memory, still works */ } }
    function draw() { const r = Math.random(); let acc = 0; for (let i = 0; i < WEIGHTS.length; i++) { acc += WEIGHTS[i]; if (r < acc) return i; } return WEIGHTS.length - 1; }
    function pick(pool) { if (!pool.length) return null; let i; do { i = Math.floor(Math.random() * pool.length); } while (pool.length > 1 && pool[i] === items[last]); last = items.indexOf(pool[i]); return pool[i]; }

    function suggestion(p, lead) {
      if (!p) return '';
      return `<a class="hwt__card hwt__card--mini" href="${esc(p.u)}"><img src="${esc(p.i)}" alt="" width="72" height="72" loading="eager" decoding="async"><span><span class="hwt__cta">${esc(lead)}</span><span class="hwt__ct">${esc(p.t)}</span><span class="hwt__cp">${esc(p.p)}</span></span></a>`;
    }

    function confetti() {
      if (reduce) return;
      const r = stage.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height * .35;
      const bits = ['🎃', '🍬', '🍭', '👻', '🦇', '✨', '🍫'];
      for (let i = 0; i < 26; i++) {
        const el = document.createElement('span');
        el.className = 'hwt__bit'; el.textContent = bits[i % bits.length];
        document.body.appendChild(el);
        const a = -Math.PI / 2 + (Math.random() - .5) * 2.6, v = 300 + Math.random() * 320, T = 1.3 + Math.random() * .5, frames = [];
        for (let k = 0; k <= 8; k++) {
          const t = (k / 8) * T;
          frames.push({ transform: `translate3d(${cx + Math.cos(a) * v * t - 12}px, ${cy + Math.sin(a) * v * t + 450 * t * t - 12}px, 0) rotate(${k * 45}deg)`, opacity: k > 5 ? 1 - (k - 5) / 3 : 1 });
        }
        el.animate(frames, { duration: T * 1000, easing: 'linear' }).onfinish = () => el.remove();
      }
    }

    function showPrize(t, repeat) {
      const tier = TIERS[t];
      const pool = tier.over ? items.filter((p) => p.n > 10000 && p.n <= 100000) : items;   // cents: $100 < price <= $1,000
      const p = pick(pool.length ? pool : items);
      const shop = tier.over ? (ds.hwtOver || '/collections/all') : (ds.hwtAll || '/collections/all');
      const apply = `/discount/${encodeURIComponent(tier.code)}?redirect=${encodeURIComponent(shop)}`;
      out.innerHTML =
        `<div class="hwt__prize${tier.jackpot ? ' is-jackpot' : ''}">
           <p class="hwt__won">${tier.jackpot ? '🎉 Jackpot!' : '🎃 You won'}</p>
           <p class="hwt__deal">${esc(tier.title)}</p>
           <div class="hwt__code"><span>Code</span><b>${esc(tier.code)}</b>
             <button type="button" class="hwt__copybtn" data-code="${esc(tier.code)}">Copy</button></div>
           <a class="btn btn--primary hwt__apply" href="${esc(apply)}">Apply &amp; shop ${tier.over ? '$100 to $1,000' : 'everything'} &rarr;</a>
           ${repeat ? '<p class="hwt__fine">Your treat is already in the bag: one prize per visitor.</p>' : ''}
           ${ds.hwtTerms ? `<p class="hwt__fine">${esc(ds.hwtTerms)}</p>` : ''}
         </div>
         ${suggestion(p, tier.over ? 'Spend it on' : 'Try it on')}`;
      stage.classList.add('is-treat');
      const copy = out.querySelector('.hwt__copybtn');
      copy.addEventListener('click', () => {
        const done = () => { copy.textContent = 'Copied!'; setTimeout(() => (copy.textContent = 'Copy'), 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(copy.dataset.code).then(done, () => {});
        else { const ta = document.createElement('textarea'); ta.value = copy.dataset.code; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); done(); } catch (e) { /* ignore */ } ta.remove(); }
      });
      if (tier.jackpot && !repeat) confetti();
      if (label) label.textContent = 'See my treat';
    }

    function showGame() {
      const trick = !lastTrick && items.length > 1 && Math.random() < .2;
      lastTrick = trick;
      if (trick) {
        out.innerHTML = '<div class="hwt__trick"><span aria-hidden="true">👻</span><b>Trick!</b> This pumpkin was empty. Knock again: the next one is a treat.</div>';
        stage.classList.add('is-trick');
      } else {
        const p = pick(items);
        out.innerHTML = `<a class="hwt__card" href="${esc(p.u)}"><img src="${esc(p.i)}" alt="" width="96" height="96" loading="eager" decoding="async"><span><span class="hwt__ct">${esc(p.t)}</span><span class="hwt__cp">${esc(p.p)}</span><span class="hwt__cta">Your treat: take a look &rarr;</span></span></a>`;
        stage.classList.add('is-treat');
      }
      if (label) label.textContent = 'Knock again';
    }

    if (!items.length && !prizes) { sec.querySelectorAll('[data-hwt-go]').forEach((b) => (b.disabled = true)); return; }

    function knock() {
      if (busy) return; busy = true;
      stage.classList.remove('is-open', 'is-treat', 'is-trick');
      out.innerHTML = '';
      stage.classList.add('is-knock');
      setTimeout(() => {
        stage.classList.remove('is-knock');
        stage.classList.add('is-open');
        if (prizes) {
          const saved = load();
          if (saved) showPrize(saved.t, true);
          else {
            const t = draw(); save(t); showPrize(t, false);
            // tell the rest of the page (the floating tab shows the code from now on)
            document.dispatchEvent(new CustomEvent('hwt:prize', { detail: { t, code: TIERS[t].code, title: TIERS[t].title } }));
          }
        } else {
          showGame();
        }
        busy = false;
      }, reduce ? 0 : 560);
    }
    sec.querySelectorAll('[data-hwt-go]').forEach((b) => b.addEventListener('click', knock));
    sec.addEventListener('hwt:knock', knock);          // the popup re-opens straight onto a saved prize
  });
})();
